/** @format */

/* eslint-disable */
import React, { useState, useEffect } from 'react'
import localize from '../../../../Global/Localize'
import { formatDate } from '../../../../Helpers/formatters'
import Checkbox from '../../../../Components/Checkbox/Checkbox'
import { getData, postData, putData } from '../../../../Helpers/webApi'
import { GlobalValidationErrors } from '../../../../Validation/ValidationState'
import { showNotification } from '../../../../Helpers/Notification/ShowNotification'
import BreadCrumb from '../../../../Components/BreadCrumb/Index'
import AddNewButton from '../../../../Components/Buttons/AddNewButton/AddNewButton'
import Loader from '../../../../Components/Loaders/Loader'
import SimpleTable from '../../../../Components/Tables/SimpleTable'
import ModalTemplate from '../../../../Components/ModalTemplate/ModalTemplate'
import Pager from '../../../../Components/Tables/Pager'
import RecordsPerPage from '../../../../Components/RecordsPerPage/RecordsPerPage'

function TrainingFacilitators() {
  const columns = [
    { label: localize('name'), template: r => <>{r?.description}</> },
    {
      label: localize('addressLine1'),
      template: r => <>{r?.addressAddressLine1}</>,
    },
    {
      label: localize('addressLine2'),
      template: r => <>{r?.addressAddressLine2}</>,
    },
    {
      label: localize('physicalAddress'),
      template: r => <>{r?.addressStreet}</>,
    },
    {
      label: localize('postalCode'),
      template: r => <>{r?.addressPostalCode}</>,
    },
    { label: localize('city'), template: r => <>{r?.addressCity}</> },
    { label: localize('emailAddress'), template: r => <>{r?.addressEmail}</> },
    { label: localize('landLine'), template: r => <>{r?.addressLandLine}</> },
    {
      label: localize('mobileLine'),
      template: r => <>{r?.addressMobileLine}</>,
    },
    {
      label: localize('internetAddress'),
      template: r => <>{r?.addressInternet}</>,
    },
    {
      label: localize('isLocked') + '?',
      template: r => (
        <span className="text-capitalize">
          {localize(r?.isLocked.toString())}
        </span>
      ),
      sortBy: 'isLocked',
    },
    { label: localize('createdBy'), template: r => <>{r?.createdBy}</> },
    {
      label: localize('createdDate'),
      template: r => <>{formatDate(r?.createdDate)}</>,
    },
  ]

  const [mode, setMode] = useState(null)
  const [selectedTrainingFacilitator, setSelectedTrainingFacilitator] =
    useState(null)
  const [isBusy, setIsBusy] = useState(false)
  const [tableData, setTableData] = useState([])
  const [search, setSearch] = useState('')
  const [reqParams, setReqParams] = useState({
    filterText: '',
    pageIndex: 0,
    pageSize: 10,
  })
  const [tableMeta, setTableMeta] = useState({ ...reqParams, itemsCount: 0 })
  const [refresh, setRefresh] = useState(false)

  useEffect(() => {
    loadTableData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reqParams.pageIndex, reqParams.pageSize, refresh])

  async function loadTableData() {
    setIsBusy(true)
    const { success, data } = await getData(
      '/TrainingFacilitator/find-by-filter-in-page',
      reqParams,
      false
    )
    if (success) {
      setIsBusy(false)
      setTableData(data.pageCollection)
      setTableMeta({ ...reqParams, itemsCount: data.itemsCount })
    }
    setIsBusy(false)
  }

  const handleAdd = () => {
    setMode('add')
    setSelectedTrainingFacilitator(null)
  }

  async function handleSubmit() {
    setIsBusy(true)
    const { success } =
      mode === 'edit'
        ? await putData(
            '/TrainingFacilitator/update',
            selectedTrainingFacilitator || {
              description: '',
            },
            false
          )
        : await postData(
            '/TrainingFacilitator/create',
            selectedTrainingFacilitator || {
              description: '',
            },
            false
          )

    if (success) {
      setIsBusy(false)
      setMode(null)
      setSelectedTrainingFacilitator(null)
      loadTableData()
      showNotification('Training Facilitator', 'success')
    }
    setIsBusy(false)
  }

  function closeModal() {
    setMode(null)
    setSelectedTrainingFacilitator(null)
    setGlobalValidationErrors({})
  }

  const [globalValidationErrors, setGlobalValidationErrors] =
    GlobalValidationErrors.use()

  function clearValidation(column) {
    setGlobalValidationErrors(validation => {
      delete validation[column]
      return validation
    })
  }

  return (
    <>
      <BreadCrumb
        tree={[
          localize('humanResourceManagement'),
          localize('trainingFacilitators'),
        ]}
      />
      <div className="row">
        <div className="col-12">
          <div className="card bg-white">
            <div className="card-body">
              <div className="row mb-2">
                <div className="col-md-4">
                  <AddNewButton handleClickAddButton={handleAdd} />
                </div>
              </div>
              {isBusy ? (
                <Loader />
              ) : (
                <>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      <RecordsPerPage
                        reqParams={reqParams}
                        setReqParams={setReqParams}
                      />
                    </div>
                    <div className="d-flex align-item-center gap-2">
                      <form
                        className="d-flex align-items-center"
                        onSubmit={e => {
                          e.preventDefault()
                          setRefresh(!refresh)
                        }}
                      >
                        <label
                          className="text-capitalize"
                          htmlFor="searchTable"
                        >
                          {localize('search')}
                        </label>
                        <input
                          type="search"
                          id="searchTable"
                          className="form-control ms-2"
                          defaultValue={reqParams.filterText}
                          onChange={e =>
                            setReqParams({
                              ...reqParams,
                              filterText: e.target.value,
                              pageIndex: 0,
                            })
                          }
                        />
                      </form>
                      <button
                        id="facilitatorFilterButton"
                        className="btn btn-primary ms-1"
                        onClick={() => setRefresh(!refresh)}
                      >
                        <i className="uil uil-filter"></i>
                      </button>
                    </div>
                  </div>
                  <div className="row col-12 mt-2">
                    <SimpleTable
                      contextMenu={r => (
                        <>
                          <div
                            className="ctxt-menu-item"
                            onClick={() => {
                              setMode('edit')
                              setSelectedTrainingFacilitator(r)
                            }}
                          >
                            <i className="uil uil-edit-alt"></i>
                            {localize('edit')}
                          </div>
                        </>
                      )}
                      data={tableData}
                      columns={columns}
                    />

                    {mode && (
                      <ModalTemplate
                        modalClassName="modal-lg"
                        modalTitle={'trainingFacilitator'}
                        modalMode={mode}
                        handleAction={handleSubmit}
                        handleClose={closeModal}
                        actionText={mode === 'add' ? 'create' : 'update'}
                        footerChildren={
                          <>
                            <div className="d-flex align-items-center me-3 gap-2">
                              <Checkbox
                                id="cTrainingFacilitatorIsLocked"
                                onCheck={e => {
                                  setSelectedTrainingFacilitator({
                                    ...selectedTrainingFacilitator,
                                    isLocked: e,
                                  })
                                }}
                                checked={selectedTrainingFacilitator?.isLocked}
                              />
                              <label
                                htmlFor="cTrainingFacilitatorIsLocked"
                                className="text-capitalize"
                              >
                                {localize('isLocked')}?
                              </label>
                            </div>
                          </>
                        }
                      >
                        {isBusy ? (
                          <Loader />
                        ) : (
                          <>
                            <div className="row mb-3 g-3">
                              <div className="col-md-12">
                                <div
                                  className="with-validation d-flex align-items-center mb-2"
                                  validation-message={
                                    globalValidationErrors['Description']
                                      ?.message
                                  }
                                >
                                  <label className="text-capitalize col-1">
                                    {localize('name')}
                                  </label>
                                  <input
                                    defaultValue={
                                      selectedTrainingFacilitator?.description
                                    }
                                    type="text"
                                    className="form-control"
                                    onChange={e => {
                                      clearValidation('Description')
                                      setSelectedTrainingFacilitator({
                                        ...selectedTrainingFacilitator,
                                        description: e.target.value,
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3 g-3">
                              <div className="col-md-6">
                                <div className="d-flex align-items-center mb-2">
                                  <label className="text-capitalize col-2">
                                    {localize('addressLine1')}
                                  </label>
                                  <input
                                    defaultValue={
                                      selectedTrainingFacilitator?.addressAddressLine1
                                    }
                                    type="text"
                                    required
                                    className="form-control"
                                    onChange={e =>
                                      setSelectedTrainingFacilitator({
                                        ...selectedTrainingFacilitator,
                                        addressAddressLine1: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex align-items-center mb-2">
                                  <label className="text-capitalize col-2">
                                    {localize('addressLine2')}
                                  </label>
                                  <input
                                    defaultValue={
                                      selectedTrainingFacilitator?.addressAddressLine2
                                    }
                                    type="text"
                                    required
                                    className="form-control"
                                    onChange={e =>
                                      setSelectedTrainingFacilitator({
                                        ...selectedTrainingFacilitator,
                                        addressAddressLine2: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3 g-3">
                              <div className="col-md-6">
                                <div className="d-flex align-items-center mb-2">
                                  <label className="text-capitalize col-2">
                                    {localize('physicalAddress')}
                                  </label>
                                  <input
                                    defaultValue={
                                      selectedTrainingFacilitator?.addressStreet
                                    }
                                    type="text"
                                    required
                                    className="form-control"
                                    onChange={e =>
                                      setSelectedTrainingFacilitator({
                                        ...selectedTrainingFacilitator,
                                        addressStreet: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex align-items-center mb-2">
                                  <label className="text-capitalize col-2">
                                    {localize('postalCode')}
                                  </label>
                                  <input
                                    defaultValue={
                                      selectedTrainingFacilitator?.addressPostalCode
                                    }
                                    type="text"
                                    required
                                    className="form-control"
                                    onChange={e =>
                                      setSelectedTrainingFacilitator({
                                        ...selectedTrainingFacilitator,
                                        addressPostalCode: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3 g-3">
                              <div className="col-md-6">
                                <div className="d-flex align-items-center mb-2">
                                  <label className="text-capitalize col-2">
                                    {localize('city')}
                                  </label>
                                  <input
                                    defaultValue={
                                      selectedTrainingFacilitator?.addressCity
                                    }
                                    type="text"
                                    required
                                    className="form-control"
                                    onChange={e =>
                                      setSelectedTrainingFacilitator({
                                        ...selectedTrainingFacilitator,
                                        addressCity: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div
                                  className="with-validation d-flex align-items-center mb-2"
                                  validation-message={
                                    globalValidationErrors['AddressEmail']
                                      ?.message
                                  }
                                >
                                  <label className="text-capitalize col-2">
                                    {localize('emailAddress')}
                                  </label>
                                  <input
                                    defaultValue={
                                      selectedTrainingFacilitator?.addressEmail
                                    }
                                    type="email"
                                    className="form-control"
                                    onChange={e => {
                                      clearValidation('AddressEmail')
                                      setSelectedTrainingFacilitator({
                                        ...selectedTrainingFacilitator,
                                        addressEmail: e.target.value,
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3 g-3">
                              <div className="col-md-6">
                                <div
                                  className="with-validation d-flex align-items-center mb-2"
                                  validation-message={
                                    globalValidationErrors['AddressLandLine']
                                      ?.message
                                  }
                                >
                                  <label className="text-capitalize col-2">
                                    {localize('landLine')}
                                  </label>
                                  <input
                                    defaultValue={
                                      selectedTrainingFacilitator?.addressLandLine
                                    }
                                    type="tel"
                                    className="form-control"
                                    onChange={e => {
                                      clearValidation('AddressLandLine')
                                      setSelectedTrainingFacilitator({
                                        ...selectedTrainingFacilitator,
                                        addressLandLine: e.target.value,
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div
                                  className="with-validation d-flex align-items-center mb-2"
                                  validation-message={
                                    globalValidationErrors['AddressMobileLine']
                                      ?.message
                                  }
                                >
                                  <label className="text-capitalize col-2">
                                    {localize('mobileLine')}
                                  </label>
                                  <input
                                    defaultValue={
                                      selectedTrainingFacilitator?.addressMobileLine
                                    }
                                    type="tel"
                                    required
                                    className="form-control"
                                    onChange={e => {
                                      clearValidation('AddressMobileLine')
                                      setSelectedTrainingFacilitator({
                                        ...selectedTrainingFacilitator,
                                        addressMobileLine: e.target.value,
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3 g-3">
                              <div className="col-md-6">
                                <div
                                  className="with-validation d-flex align-items-center mb-2"
                                  validation-message={
                                    globalValidationErrors['AddressInternet']
                                      ?.message
                                  }
                                >
                                  <label className="text-capitalize col-2">
                                    {localize('internetAddress')}
                                  </label>
                                  <input
                                    defaultValue={
                                      selectedTrainingFacilitator?.addressInternet
                                    }
                                    type="text"
                                    className="form-control"
                                    onChange={e => {
                                      clearValidation('AddressInternet')
                                      setSelectedTrainingFacilitator({
                                        ...selectedTrainingFacilitator,
                                        addressInternet: e.target.value,
                                      })
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </ModalTemplate>
                    )}
                  </div>
                  <div className="row col-12 mt-2">
                    <Pager
                      {...tableMeta}
                      onPageChange={p => {
                        setReqParams({ ...reqParams, pageIndex: p })
                      }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default TrainingFacilitators
